<template>
  <div ref="drop">
    <slot></slot>
  </div>
</template>

<script>

  export default {
    name: 'DropZone',
    methods: {
      initDrop() {
        let events = ['dragenter', 'dragover', 'dragleave', 'drop']
        let dropArea = this.$refs.drop

        events.forEach(eventName => {
          dropArea.addEventListener(eventName, (e) => {
            e.preventDefault()
            e.stopPropagation()
          }, false)
        })

        dropArea.addEventListener('drop', (e) => {
          let dt = e.dataTransfer
          let files = dt.files

          let uploads = []
          for (var i = 0; i < files.length; i++) {
            let upload = this.$api.files.save(files[i]);

            upload.then(({data}) => {
              this.$emit('paste', data.file)
            })

            uploads.push(upload)
          }

          Promise.all(uploads).then(() => {
            this.$emit('update')
          })
        }, false)
      },
    },
    mounted() {
      this.initDrop()
    }
  }
</script>
